export default "__VITE_ASSET__DPcTfEfg__"